import { isAndroid, isWeb } from "@memorang/helpers/platform";
import MaterialCommunityIcons from "@react-native-vector-icons/material-design-icons/static";
import { Pressable } from "react-native";
import { Chip } from "react-native-paper";
import type { IconType } from "../../../icon";
import { useAppTheme } from "../../../useAppTheme";

type Props = {
	content: string;
	onInsert: (content: string) => void;
	disabled?: boolean;
	position: number;
};

export const InsertableText = ({
	content,
	onInsert,
	disabled,
	position,
}: Props) => {
	const theme = useAppTheme();
	const handlePress = content !== "stem" ? () => onInsert(content) : undefined;
	const safePosition = Number.isFinite(position) ? position : 0;
	const iconName = `numeric-${safePosition}-box-outline` as IconType;

	return (
		<Pressable onPress={handlePress} disabled={disabled}>
			<Chip
				onPress={handlePress}
				disabled={disabled}
				style={{
					marginBottom: isAndroid ? -4 : -2,
					backgroundColor: theme.palette.highlight.main,
					borderRadius: theme.roundness,
					alignItems: "center",
					justifyContent: "center",
					height: 20,
					borderColor: theme.colors.text,
					opacity: disabled ? 0.5 : 1,
				}}
				textStyle={{
					fontSize: 12,
					lineHeight: 16,
					marginVertical: 0,
					marginHorizontal: 4,
					fontFamily: undefined,
					fontWeight: "500",
					color: theme.colors.shadow,
				}}
				mode="outlined"
				compact
				icon={() => (
					<MaterialCommunityIcons
						name={iconName}
						size={14}
						color={theme.colors.shadow}
						style={{ marginTop: isWeb ? 0 : -2 }}
					/>
				)}
			>
				Insert
			</Chip>
		</Pressable>
	);
};
